import { hasVendorDirectoryPermission } from "../../../auth/casamapaVendorDirectoryPermissions";
import { useVendorDirectoryPermissions } from "../../../hooks/useVendorDirectoryPermissions";

export default function VendorDirectoryPermissionGate({
  permission,
  anyOf = null,
  children,
  fallback = null,
  showRestrictedMessage = false,
}) {
  const { loading, permissions } = useVendorDirectoryPermissions();

  if (loading) {
    return null;
  }

  const allowed = anyOf
    ? anyOf.some((code) => hasVendorDirectoryPermission(permissions, code))
    : hasVendorDirectoryPermission(permissions, permission);

  if (!allowed) {
    if (showRestrictedMessage) {
      return (
        <p className="empty-state" role="status">
          You do not have permission to access this section.
        </p>
      );
    }
    return fallback;
  }

  return children;
}
